import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./LoadingScreenFluent.scss";
import { makeStyles, Text, Spinner } from "@fluentui/react-components";
import qs from "qs";
import { FormattedMessage } from "react-intl";
import configManager from "../../singleton/ConfigManager";

const useStyles = makeStyles({
  card: {
    margin: "auto",
    width: "500px",
    maxWidth: "100%",
    padding: "24px",
    paddingBottom: "12px"
  },
  cardFooter: {
    width: "100%",
    backgroundColor: "rgba(20, 20, 20, 1)"
  },
  subtitle: {
    color: "#BDBDBD"
  },
  textLoadingVerse: {
    color: "var(--White, #FFF)",
    textAlign: "center",
    fontFamily: "var(--Font-family-Base, 'Segoe UI')",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "var(--Line-height-500, 28px)"
  },
  loadingObjectsText: {
    color: " var(--Gray-3, #828282)",
    textAlign: " center",
    fontFamily: " var(--Font-family-Base, 'Segoe UI')",
    fontSize: " 10px",
    fontStyle: " normal",
    fontWeight: " 400",
    lineHeight: " normal"
  },
  emphasizedText: {
    color: "var(--White, #ffffff)"
  }
});

export function LoadingScreenFluent({ message, backgroundColor, destination }) {
  const classes = useStyles();

  const queryString = window.location.search.slice(1);
  const entryPoint = qs.parse(queryString)?.entry;

  return (
    <div
      className={styles.loadingScreenLayout}
      style={{
        backgroundColor: backgroundColor ? backgroundColor : undefined
      }}
    >
      <div style={{ display: "inline-flex", flexDirection: "column", alignItems: "center" }}>
        <Spinner size="large" appearance="primary" />
        {configManager.config.loadingScreen.showLoadingText && (
          <div style={{ paddingTop: "8px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Text className={classes.textLoadingVerse}>
              {entryPoint === "meeting" && <>Loading Meeting...</>}
              {entryPoint === "event" && <>Loading Event...</>}
              {entryPoint !== "meeting" && entryPoint !== "event" && (
                <FormattedMessage id="loading-screen.loading-verse" defaultMessage="Loading Verse" />
              )}
            </Text>

            {!destination ? (
              <Text className={classes.loadingObjectsText}>{message}</Text>
            ) : (
              <Text className={classes.loadingObjectsText}>
                <FormattedMessage
                  id="loading-screen.you-are-now-in"
                  defaultMessage="You are now in {destination}"
                  values={{
                    destination: <span className={classes.emphasizedText}>{destination}</span>
                  }}
                />
              </Text>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

LoadingScreenFluent.propTypes = {
  message: PropTypes.node,
  infoMessages: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.node.isRequired,
      message: PropTypes.node.isRequired
    })
  ),
  scene: PropTypes.object,
  objectCount: PropTypes.number,
  loadedCount: PropTypes.number,
  environmentLoaded: PropTypes.bool,
  allObjectsLoaded: PropTypes.bool,
  donePreloading: PropTypes.bool,
  backgroundColor: PropTypes.string,
  destination: PropTypes.string
};
